import type { PipelineStage } from './types';
import { a1AstExtraction } from './stages/a1-ast-extraction';
import { a2DependencyStubs } from './stages/a2-dependency-stubs';
import { a3EmbeddingRanking } from './stages/a3-embedding-ranking';
import { b1CommentWhitespaceStripping } from './stages/b1-minify';
import { b2LargeLiteralElision } from './stages/b2-elide-literals';
import { b3ErrorFocusedSlicing } from './stages/b3-error-slicing';
import { b4SemanticCompression } from './stages/b4-semantic-compression';
import { c1SendDiffsNotFiles } from './stages/c1-diff-not-files';
import { c2RequestDiffResponses } from './stages/c2-request-diff-responses';
import { d1RollingHistorySummarization } from './stages/d1-history-summarization';
import { d2PromptCachingStructure } from './stages/d2-prompt-caching-structure';
import { e1DuplicateContentStripping } from './stages/e1-duplicate-stripping';
import { e2PathAliasing } from './stages/e2-path-aliasing';
import { e3TaskTemplates } from './stages/e3-task-templates';

/**
 * The full stage list, in the exact order the spec requires them to run:
 * Group A (context selection) -> B (minification) -> C (diff workflows) ->
 * D (conversation management) -> E (prompt hygiene).
 *
 * To add a new stage: implement PipelineStage in src/pipeline/stages/, then
 * add it here in the position it should run — see README.md "Adding a new
 * optimization stage".
 */
export const PIPELINE_STAGES: PipelineStage[] = [
  a1AstExtraction,
  a2DependencyStubs,
  a3EmbeddingRanking,
  b1CommentWhitespaceStripping,
  b2LargeLiteralElision,
  b3ErrorFocusedSlicing,
  b4SemanticCompression,
  c1SendDiffsNotFiles,
  c2RequestDiffResponses,
  d1RollingHistorySummarization,
  d2PromptCachingStructure,
  e1DuplicateContentStripping,
  e2PathAliasing,
  e3TaskTemplates,
];
